import React from "react";

import { OverflowTooltip } from "components";
import { getPendStatusName } from "mappers";
import { Application, TableCellProp } from "types";

const pendStatusColumn = () => ({
	Header: "Pend Status",
	accessor: "pendStatus",
	disableSortBy: true,
	Cell: ({ row: { original } }: TableCellProp<Application>) => {
		const status = getPendStatusName(original?.pend_status);
		return (
			<OverflowTooltip onlyOnLaptop title={status}>
				{status}
			</OverflowTooltip>
		);
	},
});

export default pendStatusColumn;
